














































import { Component, Vue } from 'vue-property-decorator'
import { VQuery, VTable, QueryModel, TableHander } from '@/components/table'
import {
  SpecialPricePoolBalances,
  SpecialPricePoolRecordList,
  SpecialPricePoolAdjust,
  SpecialPriceOrderAllocateList,
  SpecialPriceOrderAllocateDetail,
} from '@/api'
import { DateFormat } from '@/utils/date/DateUtil'
import { Message } from 'element-ui'

@Component({ components: { VQuery, VTable } })
export default class SpecialPricePoolManage extends Vue {
  private balances: any[] = []
  private recordQuery: any = { startRow: 0, limit: 10, poolType: null, orderCode: '' }
  private recordTotal = 0
  private recordData: any[] = []
  private recordCurrentPage = 1
  private recordQueryModels: Array<QueryModel> = [
    { title: '池类型', param: 'poolType', type: 'select', selectData: [
      { id: 1, typeName: '市场部池' },
      { id: 2, typeName: '车奖池' },
    ] },
    { title: '订单号', param: 'orderCode' },
  ]
  private recordHander: Array<TableHander> = [
    { title: 'ID', param: 'id', width: 70 },
    { title: '池', param: 'poolLabel', width: 100 },
    { title: '类型', param: 'changeTypeLabel', width: 100 },
    { title: '方向', param: 'direction', width: 70 },
    { title: '金额', param: 'qty', width: 90 },
    { title: '余额后', param: 'balanceAfter', width: 100 },
    { title: '订单号', param: 'orderCode', minWidth: 160 },
    { title: '备注', param: 'note', minWidth: 120 },
    { title: '时间', param: 'createTime', width: 160, formatter: DateFormat },
  ]

  private allocQuery: any = { startRow: 0, limit: 10, orderCode: '' }
  private allocTotal = 0
  private allocData: any[] = []
  private allocCurrentPage = 1
  private allocQueryModels: Array<QueryModel> = [{ title: '订单号', param: 'orderCode' }]
  private allocHander: Array<TableHander> = [
    { title: '订单号', param: 'orderCode', minWidth: 180 },
    { title: '订单PV', param: 'orderPvYuan', width: 90 },
    { title: 'poolBase', param: 'poolBase', width: 90 },
    { title: '市场部池', param: 'marketPoolQty', width: 90 },
    { title: '车奖池', param: 'carAwardPoolQty', width: 90 },
    { title: '十代总池', param: 'tenGenTotalPool', width: 90 },
    { title: '十代实发', param: 'tenGenPaidQty', width: 90 },
    { title: '十代沉淀', param: 'tenGenSedimentQty', width: 90 },
    { title: '时间', param: 'createTime', width: 160, formatter: DateFormat },
    { title: '操作', width: 90, fixed: 'right', operation: [{ title: '详情', click: this.openAllocDetail }] },
  ]

  private adjustVisible = false
  private adjustForm: any = { poolType: 1, poolLabel: '', direction: 1, qty: 0, note: '' }
  private detailVisible = false
  private detail: any = null

  public created() {
    this.refreshAll()
  }

  public activated() {
    this.refreshAll()
  }

  private async refreshAll() {
    const result = await SpecialPricePoolBalances({})
    this.balances = (result && result.pools) ? result.pools : (result || [])
    await this.loadRecords()
    await this.loadAllocList()
  }

  private async loadRecords() {
    const param = { ...this.recordQuery }
    param.startRow = (this.recordCurrentPage - 1) * (param.limit || 10)
    const result = await SpecialPricePoolRecordList(param)
    this.recordData = result.list || []
    this.recordTotal = result.total || 0
  }

  private recordSizeChange(size: number) {
    this.recordCurrentPage = 1
    this.recordQuery.limit = size
    this.loadRecords()
  }

  private recordPageChange(page: number) {
    this.recordCurrentPage = page
    this.loadRecords()
  }

  private async loadAllocList() {
    const param = { ...this.allocQuery }
    param.startRow = (this.allocCurrentPage - 1) * (param.limit || 10)
    const result = await SpecialPriceOrderAllocateList(param)
    this.allocData = result.list || []
    this.allocTotal = result.total || 0
  }

  private allocSizeChange(size: number) {
    this.allocCurrentPage = 1
    this.allocQuery.limit = size
    this.loadAllocList()
  }

  private allocPageChange(page: number) {
    this.allocCurrentPage = page
    this.loadAllocList()
  }

  private openAdjust(b: any) {
    this.adjustForm = { poolType: b.poolType, poolLabel: b.poolLabel, direction: 1, qty: 0, note: '' }
    this.adjustVisible = true
  }

  private async submitAdjust() {
    if (!this.adjustForm.qty || this.adjustForm.qty <= 0) {
      Message.warning('请输入大于0的金额')
      return
    }
    await SpecialPricePoolAdjust({
      poolType: this.adjustForm.poolType,
      direction: this.adjustForm.direction,
      qty: this.adjustForm.qty,
      note: this.adjustForm.note,
    })
    Message.success('调账成功')
    this.adjustVisible = false
    await this.refreshAll()
  }

  private async openAllocDetail(row: any) {
    this.detail = await SpecialPriceOrderAllocateDetail({ orderCode: row.orderCode })
    this.detailVisible = true
  }
}
